exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.colorbtn[data-v-709b5a14] {\n  background-color: #ffe700 !important;\n}\n.colortitle[data-v-709b5a14] {\n  background-color: #27488e !important;\n  color: white;\n}\n", ""]);

// exports
